import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import { linkToCompany, nameCompany } from '../../constantValues/OTHER';

const Footer = () => (
    // main-footer-style
    <footer className={'footer main-footer-style'}>
        <Row>
            <Col md={6} xs={12} sm={6} className={'footer-left'}>
                <a href={linkToCompany} className={'footer-link-company'}>
                    Powered by <b>{nameCompany}</b>
                </a>
            </Col>
            <Col md={6} xs={12} sm={6} className={'footer-right'}>
                <a href={linkToCompany} className={'footer-link-company'}>
                    INNOVATION | PASSION | EXPERIENCE
                </a>
            </Col>
        </Row>
    </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js